import script from "./InputTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./InputTextarea.vue?vue&type=script&setup=true&lang=js"

import "./InputTextarea.vue?vue&type=style&index=0&id=7dd3c964&lang=scss"

const __exports__ = script;

export default __exports__